import React from 'react';
import get from 'lodash/get';
import {
  Button
} from '..';

export const Supplemental = (supplementalObj) => {
  const title = get(supplementalObj,'title','');
  const subtitle = get(supplementalObj,'subtitle','');
  const contentType = get(supplementalObj, 'type', {});

  const handleOnChange = (event) => {
    window.open(event.target.value, '_blank');
  }

  const determineSupplementalType = (contentType) => {
    switch(get(contentType,'content_type','')){
      case 'dropdown':
        const label = get(contentType,'dropdown_label' ,'');
        const links = get(contentType,'dropdown_links' ,[]);

        return (
          <div className="dropdown_container">
            <label for="dropdown"> {label} </label>
            <select name="dropdown" onChange={handleOnChange}>
              <option hidden={true}> {2023} </option> 
              {links.map((dropdown_link, index) => {
                let link = get(dropdown_link,'dropdown_link','');
                let label = get(dropdown_link,'drowdown_label' ,'');
                return (
                  <option key={index} value={link}> {label} </option>
                )
              })}
            </select>
          </div>
        )

      case 'button':
        let text = get(contentType,'button_text','');
        let color = get(contentType,'button_color','');
        let link = get(contentType,'button_link','');
        return (
          <a target="_blank" href={link}>
            <Button
              label={text}
              rounded
              labelHoverColor="#FFF"
              labelColor="#FFF"
              hoverColor="#000"
              bgColor={color}
              font="normal normal normal 12px/14px CentraNo2"
              letterSpacing="0.1em"
              uppercase
            />
          </a>
        )

      default:
        return '';
    }

  }
  
  return ( 
    <div className='supplemental_container'>
      <div className='text_container'>
        <p className='hed'> {title}</p>
        <p className='sub_hed'> {subtitle} </p>
      </div>
      <div className="supplemental_type">
        {determineSupplementalType(contentType)}
      </div>
    </div>
  );
}
